/**
 * import react
 */
import React from 'react';
import PropTypes from 'prop-types';

/**
 * import material-ui/core
 */
import TabelRow from '@material-ui/core/TableRow';
import TabelCell from '@material-ui/core/TableCell';

const DeviceTsdbTabelHead = (props={}) => {
  return (
    <TabelRow>
      {
        props.columns.map((col) => {
          return (
            <TabelCell key={col}>{col}</TabelCell>
          );
        })
      }
    </TabelRow>
  );
};

DeviceTsdbTabelHead.propTypes = {
  columns: PropTypes.array.isRequired
};

export default DeviceTsdbTabelHead;